import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import {useGetIdentity} from "react-admin";
import {useFormContext} from "react-hook-form";
import {ToastUiEditorView} from "toastui-editor";
import VisibilityIcon from '@mui/icons-material/Visibility';

const Transition = React.forwardRef(function Transition(
	props: TransitionProps & {
		children: React.ReactElement<unknown>;
	},
	ref: React.Ref<unknown>,
) {
	return <Slide direction="up" ref={ref} {...props} />;
});

export default function ArticlePreview() {
	const [open, setOpen] = React.useState(false);
	const form = useFormContext();
	const {title, email, tags, txtContent} = form.getValues();

	const handleClickOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	return (
		<React.Fragment>
			<Button variant="contained"  onClick={handleClickOpen}>
				<VisibilityIcon/>預覽
			</Button>
			<Dialog
				fullScreen
				open={open}
				onClose={handleClose}
				TransitionComponent={Transition}
			>
				<AppBar sx={{ position: 'relative' }}>
					<Toolbar>
						<IconButton
							edge="start"
							color="inherit"
							onClick={handleClose}
							aria-label="close"
						>
							<CloseIcon />
						</IconButton>
						<Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
							{title}預覽
						</Typography>
						<Button autoFocus color="inherit" onClick={handleClose}>
							返回
						</Button>
					</Toolbar>
				</AppBar>
				<div className="bg-[#e2e2e2] pt-[10px] flex-grow">
					<div className="bg-white max-w-[930px] mx-auto p-6">
						<div className="px-5">
							<div className="mb-3">
								<h1 className="text-3xl font-bold text-blue-gray-900">{title}</h1>
							</div>
							{/* Metadata */}
							<div className="flex flex-col md:flex-row gap-2 md:gap-6 md:items-center mb-[50px] md:mb-10">
								<div className="flex gap-2 items-center flex-shrink-0">
									<div className="text-[14px] font-bold text-blue-gray-800">
										{/* Author Name */}
										作者：{email}
									</div>
									<div className="flex gap-1 items-center text-xs text-blue-gray-500 font-medium">
										{/* Date */}
										<AccessTimeIcon />

										{new Date().toISOString().split('T')[0]}
									</div>
								</div>
								<div className="flex overflow-x-auto whitespace-nowrap gap-2">
									{tags?.map(
											(tag: string) => (<div key={tag} className="p-1 bg-gray-100 rounded">{tag}</div>))}
								</div>
							</div>
						</div>
						<ToastUiEditorView initialValue={txtContent}/>
					</div>
				</div>
			</Dialog>
		</React.Fragment>
	);
}
